// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { SupabaseClient } from '@supabase/supabase-js';
import type { Database } from './types';
import { validateSupabaseConfig } from './config';

const supabaseConfigResult = validateSupabaseConfig(import.meta.env);

export const supabaseConfigError = supabaseConfigResult.ok ? null : supabaseConfigResult.message;

if (supabaseConfigError) {
  console.error(supabaseConfigError);
}

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = (supabaseConfigResult.ok
  ? createClient<Database>(supabaseConfigResult.config.url, supabaseConfigResult.config.publishableKey, {
      auth: {
        storage: typeof window !== "undefined" ? window.localStorage : undefined,
        persistSession: true,
        autoRefreshToken: true,
      },
    })
  : null) as SupabaseClient<Database>;
